import { useState } from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import useApiFetch from '@/hooks/useApiFetch';
import staffMemberService, { ListStaffMembersResponse } from '@/services/staffMember';
import { chakraExtendedTheme } from '@/styles/theme';
import { PaginationProps } from '@/trio-ui/Pagination/Pagination.component';
import { FetchApiIds } from '@/types';
import StaffComponent from './Staff.component';

const Staff = (): JSX.Element => {
  const [showExportModal, setShowExportModal] = useState<boolean>(false);
  const [isAddNewMemberModalOpen, setIsAddNewMemberModalOpen] = useState<boolean>(false);
  const [search, setSearch] = useState<string>('');
  const [pagination, setPagination] = useState<
    Pick<PaginationProps, 'currentPage' | 'itemsPerPage'>
  >({
    currentPage: 1,
    itemsPerPage: 10,
  });

  const staffMembersResponse = useApiFetch<ListStaffMembersResponse>(
    [FetchApiIds.LIST_STAFF_MEMBERS, pagination.currentPage, pagination.itemsPerPage, search],
    async () =>
      staffMemberService.listStaffMembers({
        take: pagination.itemsPerPage,
        page: pagination.currentPage,
        term: search,
      })
  );

  const handleChangePageHandler = (page: number): void => {
    setPagination((prev) => ({
      ...prev,
      currentPage: page,
    }));
  };

  const handleChangeRecordsPerPage = (records: number): void => {
    setPagination((prev) => ({
      ...prev,
      itemsPerPage: records,
    }));
  };

  return (
    <ChakraProvider theme={chakraExtendedTheme}>
      <StaffComponent
        members={staffMembersResponse.data?.data || []}
        isLoading={staffMembersResponse.isLoading}
        onChangePageHandler={handleChangePageHandler}
        onChangeRecordsPerPage={handleChangeRecordsPerPage}
        count={staffMembersResponse.data?.count || 0}
        lastPage={staffMembersResponse.data?.lastPage || 1}
        isExportModalOpen={showExportModal}
        onOpenExportModal={() => setShowExportModal(true)}
        onCloseExportModal={() => setShowExportModal(false)}
        search={search}
        onSearchChange={setSearch}
        isAddNewMemberModalOpen={isAddNewMemberModalOpen}
        setIsAddNewMemberModalOpen={setIsAddNewMemberModalOpen}
        onUpdateList={staffMembersResponse.refetch}
        {...pagination}
      />
    </ChakraProvider>
  );
};

export default Staff;
